<div class="row">
    <div class="col-md-12 col-xs-12" *ngIf="vehicleList?.length > 0">
     <div class="row pb-4">
      <!-- <div class="col-md-10 col-sm-6 col-xs-12 text-right">
         <ul class="view mt-2">
            <li (click)="toggleView('list')"  class="d-inline m-1"><a><i class="fa fa-list-ul" aria-hidden="true"></i></a></li>
            <li (click)="toggleView('cards')" class="d-inline m-1"><a><i class="fa fa-th-large" aria-hidden="true"></i></a></li>
            <li (click)="toggleView('list2')" class="d-inline m-1"><a><i class="fa fa-th-list" aria-hidden="true"></i></a></li>
        </ul>
      </div> -->
      <div class="col-md-12 col-sm-6 col-xs-12" *ngIf="vehicleList.length > 0">
        <nav aria-label="Page navigation example">
            <ul class="pagination pagination-md justify-content-end">
                <li (click)="toggleView('list')"  class="view d-inline mr-2"><a><i class="fa fa-list-ul" aria-hidden="true"></i></a></li>
                <li (click)="toggleView('cards')" class="view d-inline mr-2"><a><i class="fa fa-th-large" aria-hidden="true"></i></a></li>
                <li (click)="toggleView('list2')" class="view d-inline mr-2 pr-3"><a><i class="fa fa-th-list" aria-hidden="true"></i></a></li>
                <li [ngClass]="PageId == 1 ? 'page-item disabled' : 'page-item'" (click)="previous()">
                    <span class="page-link">Previous</span>
                </li>
                <li [ngClass]="page.Id == PageId ? 'page-item active' : 'page-item'"
                    *ngFor="let page of PageList" (click)="onPageChange(page.Id)">
                    <span class="page-link">
                        {{page.Description}}
                        <span class="sr-only">(current)</span>
                    </span>
                </li>
                <li [ngClass]="PageId == PageList.length ? 'page-item disabled' : 'page-item'" (click)="next()">
                    <a class="page-link">Next</a>
                </li>
            </ul>
        </nav>
       </div>
      </div>
    </div>
    <div *ngIf="view === 'list'" class="col-lg-12 col-xs-12">
        <div *ngFor="let item of vehicleList; let i = index;">
          <div class="search_details style4 md-grid">
            <div class="row">
              <div class="col-md-6 col-lg-3 col-md-auto">
                <div class="thumb" (click)='navigate(item)'>
                  <div class="fp_single_item_slider">
                    <div class="item">
                      <img [hidden]="!imageLoader" class="imgload" src="assets/img/loader1.gif" />
                      <img [hidden]="!imageLoader" [src]="noImageUrl" class="no-img-whp">                                         
                      <img [hidden]="imageLoader" [src]='getImage(item?.Images)'
                        (load)="this.imageLoader = false;" class="img-whp" alt="Vehicle">
                    </div>
                  </div>
                </div>
                <div class="grid-title">
                 <h1><span class="sub-title font-18 fontweight700 text-deepblue">{{item.VehicleDescriptionSubTitle}}</span></h1>
                </div>
              </div>
              <div class="col-md-6 col-lg-6">
                <div class="details">
                  <div class="tc_content">
                    <p class="title pt-3">
                      <a (click)='navigate(item)' class="text-greydeep">{{item.VehicleDescriptionTitle}}</a>
                    </p>
<!--                                 <span *ngIf="groupName != 'Enterprise'">
                      <span (click)="addToFavorite(item, i);"
                        [ngClass]="item.FavProductId == 0 ? 'show' : 'hide'">
                        <i class="far fa-heart pull-right heart" data-toggle="tooltip"
                          data-placement="top" title="Add to Favorite"></i>
                      </span>
                      <span (click)="removeFavorite(item, i);"
                        [ngClass]="item.FavProductId > 0 ? 'show' : 'hide'">
                        <i class="fas fa-heart pull-right heart" data-toggle="tooltip"
                          data-placement="top" title="Remove from Favorite"></i>
                      </span>
                    </span> -->
                    <!-- <span class="sub-title">{{item.VehicleDescriptionSubTitle}}</span> -->
                  </div>
                  <div class="row">
                    <div class="col-md-12 col-xs-12">
                      <ul class="prop_details mb0">
                                <li class="d-block font-16 text-body" title="Auction Close">
                                    <span class="text-green fontweight600 mr-1"><i class="fa fa-calendar" aria-hidden="true"></i> Start:</span>  <span class="font-15 fontweight600">{{item.StartDate | date:'MMM d, y, h:mm a'}}</span>
                                    <!-- , h:mm a -->
                                </li>
                                <li class="d-block font-16 text-body" title="Auction Close">
                                    <span class="text-danger fontweight600 mr-1"><i class="fa fa-calendar" aria-hidden="true"></i> End:</span> <span class="font-15 fontweight600">{{item.EndDate | date:'MMM d, y, h:mm a'}}</span>
                                </li>
                                <li *ngIf="item.PublicViewingStartTime" class="d-block font-16 text-body" title="Location">
                                    <span class="text-greydeep mr-1 fontweight600">Location:</span> <span class="font-15 fontweight600">{{item.StorageLocationName}} </span>
                                </li>
                                <li *ngIf="item.PublicViewingEndTime" class="d-block font-16 text-body" title="Address">
                                    <span class="text-greydeep mr-1 fontweight600">Address:</span> <span class="font-15 fontweight600">{{item.StorageLocationAddress}} </span>
                                </li>
<!--                                     <li class="font13 redColor" title="Auction Close">
                          Starts&nbsp;{{item.StartDate | date:'MMM d, y, h:mm a'}}
                        </li>
                        <li class="font13 redColor" title="Auction Close">
                          Ends&nbsp;{{item.EndDate | date:'MMM d, y, h:mm a'}}
                        </li>
                        <li *ngIf="item.PublicViewingStartTime" class="font13 greenColor" title="Location">
                          Location: &nbsp;{{item.StorageLocationName}}
                        </li>
                        <li *ngIf="item.PublicViewingEndTime" class="font13 greenColor" title="Address">
                          Address: &nbsp;{{item.StorageLocationAddress}}
                        </li> -->
                      </ul>
                    </div>
                    <div class="col-md-12 col-xs-12">
                      <ul class="prop_details mb0 text-center border-top pt-3 mt-5">
                        <li *ngIf="item.PublicViewingDate" class="d-block font-18 text-blue fontweight700" title="Public Viewing Date">
                          Public Viewing Date&nbsp;{{item.PublicViewingDate | date:'MMM d, y'}}
                        </li>
                      <span class="d-block font-16 text-body">
                        <span class="d-inline text-greydeep fontweight600">Timing:</span>
                        <li *ngIf="item.PublicViewingStartTime" class="d-inline text-body font-15" title="Start Time">
                          <span class="font-15 fontweight600"> {{item.PublicViewingStartTime}} </span>
                        </li>
                        <li *ngIf="item.PublicViewingEndTime" class="d-inline text-body font-15" title="End Time">
                          <span class="font-15 fontweight600"> {{item.PublicViewingEndTime}} </span>
                        </li>
                     </span>
                      </ul>
                    </div>
<!--                                 <div class="col-md-6">
                      <ul class="prop_details mb0">
                        <li *ngIf="item.PublicViewingStartTime" class="font13 greenColor" title="Location">
                          Location: &nbsp;{{item.StorageLocationName}}
                        </li>
                        <li *ngIf="item.PublicViewingEndTime" class="font13 greenColor" title="Address">
                          Address: &nbsp;{{item.StorageLocationAddress}}
                        </li>
                      </ul>
                    </div> -->
                  </div>
                  <div *ngIf="vehicleList.length == 0">
                    No Record Found
                  </div>
                </div>
              </div>
              <div class="col-md-12 col-lg-3 col-xs-12">
                      <div class="grid-bidder text-center p-5">
                         <span class="d-block total-bid text-danger font-weight-bolder font-22" title="Total Bids">
                            <i class="fa fa-gavel" aria-hidden="true"></i> Total Bids: {{item.NoofBids}}
                        </span>
                        <span class="d-block text-grey font-weight-bold" title="Current Total Bid Amount" >
                          Current Bid: <span class="text-danger"> {{item.CurrentBid | currency: 'USD'}}</span>
                        </span>
                        <span class="d-block text-grey font-weight-bold font-16">Sale No: {{item.SaleNo}}</span>
                      </div>
                    <div class="grid-favourite text-center" *ngIf="groupName != 'Enterprise'">
                      <span (click)="addToFavorite(item, i);"
                        [ngClass]="item.FavProductId == 0 ? 'show' : 'hide'">
                        <i class="far fa-heart heart" data-toggle="tooltip"
                          data-placement="top" title="Add to Favorite"></i>
                      </span>
                      <span (click)="removeFavorite(item, i);"
                        [ngClass]="item.FavProductId > 0 ? 'show' : 'hide'">
                        <i class="fas fa-heart heart" data-toggle="tooltip"
                          data-placement="top" title="Remove from Favorite"></i>
                      </span>
                  </div>
                 <div class="d-block text-center">
                    <button type="button" color="primary" class="btn btn-auction" (click)="OpenAuctionInfoModal(item.ProductId)">Auction Info <i class="fa fa-info-circle" aria-hidden="true"></i></button>
                 </div>
             </div>

            </div>
          </div>
        </div>
      </div>                  


      <div *ngIf="view === 'list2'" class="col-lg-12 col-xs-12">
        <div *ngFor="let item of vehicleList; let i = index;">
          <div class="search_details2 thumb thumb-grid">
            <div class="row row-eq-height align-items-center g-2">
              <div class="col-1 hola p-2">
                <div class="thumb" (click)='navigate(item)'>
                  <div class="fp_single_item_slider">
                    <div class="thumbnail-img">
                      <img [hidden]="!imageLoader" class="imgload thumbnail-img" src="assets/img/loader1.gif" />
                      <img [hidden]="!imageLoader" [src]="noImageUrl" class="no-img-whp thumbnail-img">                                         
                      <img [hidden]="imageLoader" class="thumbnail-img" [src]='getImage(item?.Images)'
                        (load)="this.imageLoader = false;" alt="Vehicle">
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-9 col-lg-9 col-xs-12">
                <div class="details">
                    <div class="tc_content">
                        <p class="title">
                            <a (click)='navigate(item)' class="ptext"
                                style="color: blue;text-decoration: underline;">{{item.VehicleDescriptionTitle}}
                            </a>
                        </p>
                        <span class="sub-title">{{item.VehicleDescriptionSubTitle}}</span>
                        <ul class="prop_details mb0">
<!--                                         <li class="list-inline-item font13 floatleft" title="Current Total Bid Amount">
                                Current Bid:
                                <span class=" priceColor">{{item.CurrentBid | currency: 'USD'}}</span>
                            </li>
                            <li class="list-inline-item font13 floatright" title="Total Bids">Total Bids:
                                <span class=" priceColor">{{item.NoofBids}}</span>
                            </li> -->
                            <li class="font-13 text-body d-inline" title="Auction Close">
                                <span class="text-green fontweight600 mr-1"><i class="fa fa-calendar" aria-hidden="true"></i> Start:</span> <span class="font-15 fontweight600">{{item.StartDate | date:'MMM d, y, h:mm a'}} </span>
                                <!-- , h:mm a -->
                            </li>
                            <li class="font-13 text-body d-inline" title="Auction Close">
                                <span class="text-danger fontweight600 mr-1"><i class="fa fa-calendar" aria-hidden="true"></i> End:</span> <span class="font-15 fontweight600">{{item.EndDate | date:'MMM d, y, h:mm a'}} </span>
                            </li>

                            <li *ngIf="item.PublicViewingStartTime" class="font-13 text-body d-inline" title="Location">
                                <span class="text-greydeep mr-1 fontweight600">Location:</span> 
                                <span class="font-15 fontweight600"> {{item.StorageLocationName}} </span>
                            </li>
                            <li *ngIf="item.PublicViewingEndTime" class="font-13 text-body d-inline" title="Address">
                                <span class="text-greydeep mr-1 fontweight600">Address:</span>
                                <span class="font-15 fontweight600"> {{item.StorageLocationAddress}} </span>
                            </li>
                        </ul>
                        <ul class="prop_public mb0">
                            <li *ngIf="item.PublicViewingDate" class="font-15 text-blue fontweight700 d-inline" title="Public Viewing Date">
                                Public Viewing Date&nbsp;{{item.PublicViewingDate | date:'MMM d, y'}}
                            </li>
                            <span class="d-inline text-greydeep fontweight600">Timing:</span>
                            <li *ngIf="item.PublicViewingStartTime" class="text-body font-15 d-inline" title="Start Time">
                               <span class="font-15 fontweight600"> {{item.PublicViewingStartTime}} </span>
                            </li>
                            <li *ngIf="item.PublicViewingEndTime" class="text-body font-15 d-inline" title="End Time">
                                <span class="font-15 fontweight600"> {{item.PublicViewingEndTime}} </span>
                            </li>
                        </ul>
                    </div>
                    <div *ngIf="vehicleList.length == 0">
                        No Record Found
                    </div>
                </div>
              </div>
              <div class="col-md-2 col-lg-2 col-xs-12">
                    <div class="grid-bidder text-center">
                            <span class="d-block total-bid text-danger font-weight-bolder font-22" title="Total Bids">Total Bids: {{item.NoofBids}} </span>
                            <span class="-block text-grey font-weight-bold" title="Current Total Bid Amount">
                                Current Bid: {{item.CurrentBid | currency: 'USD'}}
                            </span>
                            <span class="d-block text-grey font-weight-bold font-14">Sale No: {{item.SaleNo}}</span>

                    </div>
                    <div class="grid-favourite text-center" *ngIf="groupName != 'Enterprise'">
                            <span (click)="addToFavorite(item, i);"
                                [ngClass]="item.FavProductId == 0 ? 'show' : 'hide'">
                                <i class="far fa-heart pull-right heart" data-toggle="tooltip"
                                    data-placement="top" title="Add to Favorite"></i>
                            </span>
                            <span (click)="removeFavorite(item, i);"
                                [ngClass]="item.FavProductId > 0 ? 'show' : 'hide'">
                                <i class="fas fa-heart pull-right heart" data-toggle="tooltip"
                                    data-placement="top" title="Remove from Favorite"></i>
                            </span>
                        </div>
                     <div class="d-block text-center">
                        <button type="button" color="primary" class="btn btn-auction btn-grid" (click)="OpenAuctionInfoModal(item.ProductId)">Auction Info <i class="fa fa-info-circle" aria-hidden="true"></i></button>
                     </div>

              </div>
            </div>
          </div>
        </div>
      </div>

    
    <div *ngIf="view === 'cards'" class="col-lg-12 col-xs-12">
        <div class="row">
            <div class="col-md-6 col-lg-3" *ngFor="let item of vehicleList;let i=index;">
                <div class="search_details home7 style4 card-style">
                    <div class="thumb" (click)='navigate(item)'>
                        <div class="fp_single_item_slider">
                            <div class="item">
                                <img [hidden]="!imageLoader" class="imgload" src="assets/img/loader1.gif" />
                                <img [hidden]="!imageLoader" [src]="noImageUrl" class="no-img-whp">                                         
                                <img [hidden]="imageLoader" [src]='getImage(item?.Images)'
                                    (load)="this.imageLoader = false;" class="img-whp" alt="Vehicle" style="width: 680px!important;">
                            </div>
                        </div>
                    </div>
                    <div class="details">
                        <div class="card-title">
                           <span class="car-subtitle">{{item.VehicleDescriptionSubTitle}}</span>

                            <span class="favorite" *ngIf="groupName != 'Enterprise'">
                                <span (click)="addToFavorite(item, i);"
                                    [ngClass]="item.FavProductId == 0 ? 'show' : 'hide'">
                                    <i class="far fa-heart" data-toggle="tooltip"
                                        data-placement="top" title="Add to Favorite"></i>
                                </span>
                                <span (click)="removeFavorite(item, i);"
                                    [ngClass]="item.FavProductId > 0 ? 'show' : 'hide'">
                                    <i class="fas fa-heart" data-toggle="tooltip"
                                        data-placement="top" title="Remove from Favorite"></i>
                                </span>
                            </span>
                        </div>
                        <div class="bidder-section px-2">
<!--                             <span class="d-block total-bid text-danger font-weight-bolder"> Total Bids: {{item.NoofBids}}</span>
                            <span class="d-block text-grey font-weight-bold"> Current Bid: <span class="text-danger">{{item.CurrentBid | currency: 'USD'}}</span></span>
                            <span class="d-block text-grey font-weight-bold font-16">Sale No: {{item.SaleNo}}</span>
                            <span class="d-block font-weight-normal font-18"> 
                                <a (click)='navigate(item)' class="text-dark text-description"
                                    style="color: blue;text-decoration: underline;">{{item.VehicleDescriptionTitle}}
                                </a>
                            </span> -->
                            <div class="row">
                                        <div class="col-md-5 col-xs-12">
                                        <span class="total-bid font-weight-bolder"> <span class="text-grey font-weight-bold"> Total Bids: </span> <span class="text-danger font-18">{{item.NoofBids}}</span> </span>
                                        </div>
                                          <div class="col-md-7 col-xs-12 text-right">
                                             <div class="current-bid text-grey font-weight-bold"> Current Bid: <span class="text-danger">{{item.CurrentBid | currency: 'USD'}}</span></div>
                                          </div>
                                         </div>
                                         
                                         <div class="row mt-1">
                                          <div class="col-md-8 col-xs-12">
                                           <div class="font-weight-normal mt-1"> 
                                            <a (click)='navigate(item)' class="text-dark text-description"
                                                style="color: blue;text-decoration: underline;">{{item.VehicleDescriptionTitle}}
                                            </a>
                                           </div>
                                          </div>
                                          <div class="col-md-4 col-xs-12 text-right">
                                            <div class="tag">Sale No: {{item.SaleNo}}</div>
                                          </div>

                                       </div>
                        </div>
                        <div class="tc_content">
<!--                                         <p class="title">
                                <a (click)='navigate(item)' class="ptext"
                                    style="color: blue;text-decoration: underline;">{{item.VehicleDescriptionTitle}}
                                </a>
                            </p> -->
<!--                                         <span *ngIf="groupName != 'Enterprise'">
                                <span (click)="addToFavorite(item, i);"
                                    [ngClass]="item.FavProductId == 0 ? 'show' : 'hide'">
                                    <i class="far fa-heart pull-right heart" data-toggle="tooltip"
                                        data-placement="top" title="Add to Favorite"></i>
                                </span>
                                <span (click)="removeFavorite(item, i);"
                                    [ngClass]="item.FavProductId > 0 ? 'show' : 'hide'">
                                    <i class="fas fa-heart pull-right heart" data-toggle="tooltip"
                                        data-placement="top" title="Remove from Favorite"></i>
                                </span>
                            </span> -->
                            <!-- <span class="sub-title">{{item.VehicleDescriptionSubTitle}}</span> -->
                             <div class="prop_details mb0 pt-0 pb-3 border-bottom">
                                           <div class="row mx-lg-n5 px-4">
                                            <div class="col-md-12 col-xs-12">
                                                <div class="d-block font-15 text-body" title="Auction Close">
                                                 <span class="circle"><i class="fa fa-calendar" aria-hidden="true"></i></span> <span class="d-inline text-green fontweight600 mr-1"> Start:</span>  <span class="d-inline font-15 fontweight600">{{item.StartDate | date:'MMM d, y, h:mm a'}}</span>
                                                    <!-- , h:mm a -->
                                                </div>
                                              <div class="d-block font-15 text-body" title="Auction Close">
                                                <span class="circle"><i class="fa fa-calendar" aria-hidden="true"></i></span><span class="d-inline text-danger fontweight600 mr-1"> End:</span> <span class="d-inline font-15 fontweight600">{{item.EndDate | date:'MMM d, y, h:mm a'}}</span>
                                              </div>
                                           </div>
                                          <div class="col-md-12 col-xs-12">
                                            <span *ngIf="item.PublicViewingStartTime" class="d-block font-16 text-body" title="Location">
                                                <span class="circle fontweight600"><i class="fa fa-location-arrow" aria-hidden="true"></i></span> <span class="font-15 fontweight600"> {{item.StorageLocationName}} </span>
                                            </span>
                                          </div>
                                          <div class="col-md-12 col-xs-12">
                                            <span *ngIf="item.PublicViewingEndTime" class="d-block font-16 text-body" title="Address">
                                                <span class="circle fontweight600"><i class="fa fa-address-card" aria-hidden="true"></i></span> <span class="font-15 fontweight600"> {{item.StorageLocationAddress}} </span>
                                            </span>
                                          </div>
                                         </div>
                                        </div>
<!--                             <ul class="prop_details mb0 pt-2 pb-3 border-bottom">
                                <li class="d-block font-16 text-body" title="Auction Close">
                                    <span class="text-green fontweight600 mr-1"><i class="fa fa-calendar" aria-hidden="true"></i> Start:</span>  <span class="font-15 fontweight600">{{item.StartDate | date:'MMM d, y, h:mm a'}}</span>
                                </li>
                                <li class="d-block font-16 text-body" title="Auction Close">
                                    <span class="text-danger fontweight600 mr-1"><i class="fa fa-calendar" aria-hidden="true"></i> End:</span> <span class="font-15 fontweight600">{{item.EndDate | date:'MMM d, y, h:mm a'}}</span>
                                </li>
                                <li *ngIf="item.PublicViewingStartTime" class="d-block font-16 text-body" title="Location">
                                    <span class="text-greydeep mr-1 fontweight600">Location:</span> <span class="font-15 fontweight600">{{item.StorageLocationName}} </span>
                                </li>
                                <li *ngIf="item.PublicViewingEndTime" class="d-block font-16 text-body" title="Address">
                                    <span class="text-greydeep mr-1 fontweight600">Address:</span> <span class="font-15 fontweight600">{{item.StorageLocationAddress}} </span>
                                </li>
                            </ul> -->
 <!--                            <ul class="prop_details mb0 text-center bg-grey">
                                <li *ngIf="item.PublicViewingDate" class="d-block font-18 text-blue fontweight700" title="Public Viewing Date">
                                    Public Viewing Date {{item.PublicViewingDate | date:'MMM d, y'}}
                                </li>
                                 <span class="d-block font-16 text-body">
                                    <span class="d-inline text-greydeep fontweight600">Timing:</span>
                                    <li *ngIf="item.PublicViewingStartTime" class="d-inline text-body font-15" title="Start Time">
                                        <span class="font-15 fontweight600"> {{item.PublicViewingStartTime}}</span>
                                    </li> -
                                    <li *ngIf="item.PublicViewingEndTime" class="d-inline text-body font-15" title="End Time">
                                         <span class="font-15 fontweight600"> {{item.PublicViewingEndTime}}</span>
                                    </li>
                                </span>
                                <li class="d-block text-center pt-3 pb-2">
                                   <button type="button" color="primary" class="btn btn-auction" (click)="OpenAuctionInfoModal(item.ProductId)">Auction Info <i class="fa fa-info-circle" aria-hidden="true"></i></button>
                                </li>
                            </ul> -->
                                  <div class="prop_details public-view mb0">
                                          <div class="row mx-lg-n5 px-4">
                                           <div class="col-md-12 col-xs-12 text-left">
                                            <span *ngIf="item.PublicViewingDate" class="public-text d-block text-blue fontweight700" title="Public Viewing Date">
                                                Public Viewing Date {{item.PublicViewingDate | date:'MMM d, y'}}
                                            </span>
                                           </div>
                                           <div class="col-md-12 col-xs-12">
                                                <span class="time-text d-inline text-greydeep fontweight600">Timing:</span>
                                                <span *ngIf="item.PublicViewingStartTime" class="time-text d-inline text-body fontweight600" title="Start Time"> {{item.PublicViewingStartTime}} </span> -
                                                <span *ngIf="item.PublicViewingEndTime" class="time-text d-inline text-body fontweight600 mr-3" title="End Time"> {{item.PublicViewingEndTime}}</span>
                                                <span class="time-text d-inline text-body"><button type="button" color="primary" class="btn btn-auction" (click)="OpenAuctionInfoModal(item.ProductId)">Auction Info <i class="fa fa-info-circle" aria-hidden="true"></i></button></span>
                                           </div>
                                        </div>
                                      </div>
                        </div>
                        <div *ngIf="vehicleList.length == 0">
                            No Record Found
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>